import { IPlanType } from "../../../services/api/planEnrollment/types";
import React from "react";
import { AboutOAI } from "../../Benefits/components/customBenefits/OAI/AboutOAI";
import { AboutPGLI } from "../../Benefits/components/customBenefits/PGLI/AboutPGLI";

export const selectorAboutPlanByPlanType = (
  planType: IPlanType
): React.ReactNode => {
  const names: Record<IPlanType, React.ReactNode> = {
    WingspanOccupationalAccidentInsurance: <AboutOAI />,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance: <AboutPGLI />,
    MeridioHealth: <>TODO</>
  };

  return names[planType] || <></>;
};
